import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import * as fromRouterActions from '@jepto/shared/store/router/actions/router.action';
import { log, warn } from '@jepto/shared/utils/logger';

/** Resolve a Go navigation path, falling back when client anomaly routes contain nullish segments. */
export function resolveGoNavigationPath(path: string[]): string[] | null {
	if (!path.some(segment => segment == null)) {
		return path;
	}

	if (path[0] === 'clients' && path[2] === 'anomalies') {
		return ['anomalies'];
	}

	return null;
}

@Injectable()
export class RouterEffects {

    navigate$ = createEffect(() => this.actions$.pipe(
        ofType(fromRouterActions.GO),
        map((action: fromRouterActions.Go) => action.payload),
        tap(({ path, query: queryParams, extras }) => {
            log("RouterEffects:: ", path)
            log("RouterEffects:: ", { queryParams, ...extras })

            const resolvedPath = resolveGoNavigationPath(path);
            if (!resolvedPath) {
                if (path.some(segment => segment == null)) {
                    warn(
                        'RouterEffects: blocked navigation with nullish path segment',
                        { path }
                    );
                }
                return;
            }

            if (path.some(segment => segment == null)) {
                warn(
                    'RouterEffects: nullish client segment in anomalies navigation, using global anomalies list',
                    { path }
                );
            }

            this.router.navigate(resolvedPath, { queryParams, ...extras })
        }
        )
    ), { dispatch: false });

    navigateBack$ = createEffect(() => this.actions$.pipe(
        ofType(fromRouterActions.BACK),
        tap(() => this.location.back())
    ), { dispatch: false });


    navigateForward$ = createEffect(() => this.actions$.pipe(
        ofType(fromRouterActions.FORWARD),
        tap(() => this.location.forward())
    ), { dispatch: false });

    constructor(
        private actions$: Actions,
        private router: Router,
        private location: Location
    ) { }
}
